module.exports = __webpack_public_path__ + "img/20.e848f097.png";